// extracted by mini-css-extract-plugin
export default {"header":"styles_header__A80Dq","left_side":"styles_left_side__H+Cx3","avtar_arrow":"styles_avtar_arrow__d63UA","textWrapper":"styles_textWrapper__VUFPQ"};